
String.prototype.equals = function(target): boolean {
    return this == target;
}

String.prototype.isEmpty = function(): boolean {
    return this == '' || this == null;
}

Array.prototype.isEmptyArray = function(): boolean {
    return this.length === 0;
}

Date.prototype.convert = function(): string {
    const year = this.getFullYear();
    const month = this.getMonth() + 1;
    const day = this.getDate();

    return `${year 
           }-${  month > 9? '': '0' }${month 
           }-${  day > 9 ? '': '0'  }${day}`;
}

String.prototype.decode = function(): string {
    let s = this.replace(/\+/g, ' ');

    s = s.replace(/%(?![0-9A-Fa-f]{2})/g, '%25');

    try {
        return decodeURI(s);
    } catch (e) {
        try {
            return decodeURI(encodeURI(s));
        } catch (e2) {
            return s;
        }
    }
}